module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jgLNzX/tc-custom/9781549302473.jpg?1729185238158",
      "alt": "This image is the cover for the book Accell Vol. 2: Pop Quiz, Accell"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Accell Vol. 2: Pop Quiz, Accell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Running faster than the speed of sound and beating up bad guys on the weekends sounded like the high life, right? That’s what Daniel Dos Santos first thought when he put on the costume. Now Daniel is finding out things aren’t so simple. Not with an array of colorfully costumed baddies coming out of the woodwork every other day. Not when you have to balance paying bills, a girlfriend, a friendly ghost, and one very upset abuela who just wants you to call, on top of said baddies.  With new faces showing up on the block offering both aid and harm, is Daniel ready for the next set of challenges that face him?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Casey, Damion Scott, Robert Campanella, Sigmund Torre\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joe Casey is an American comic book writer. He has worked on titles such as Wildcats 3.0, Uncanny X-Men, The Intimates, Adventures of Superman, and G.I. Joe: America's Elite among others. As part of the comics creator group Man of Action Studios, Casey is one of the creators of the animated series Ben 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0